module.exports = __webpack_public_path__ + "img/EN－注册２.6619a478.png";